/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { userInfo?: API.UserProfile } | undefined) {
  const { userInfo } = initialState ?? {};
  return {
    canAdmin: userInfo && userInfo.is_admin,
    userInfo
  };
}
